module.exports = __webpack_public_path__ + "static/media/ET071 new.bc252ce5.jpg";